

import React from "react";
import "../css/contact.css";

const ContactInfo = () => {
  return (
    <>

     <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Contact Us
        </h2>
      </div>
    </section>
      <section className="contact-section">

        <div className="container">

          <div className="row justify-content-center">

            {/* Phone */}
            <div className="col-lg-4 col-md-6 mb-4">

              <div className="contact-box">

                <div className="contact-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>

                <div className="contact-content">

                  <h4>Phone Support</h4>

                  <p>
                    <a href="tel:+917776814559">
                      +91 7776814559
                    </a>
                  </p>

                  <p>
                    <a href="tel:+919579032227">
                      +91 9579032227
                    </a>
                  </p>

                

                  <span>24×7 Travel Assistance</span>

                </div>

              </div>

            </div>

            {/* Email */}

            <div className="col-lg-4 col-md-6 mb-4">

              <div className="contact-box">

                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>

                <div className="contact-content">

                  <h4>Email Support</h4>

                  <p>
                    <a href="mailto:booking@saishirdicabs.com">
                      booking@saishirdicabs.com
                    </a>
                  </p>

                  <span>Reply Within 24 Hours</span>

                </div>

              </div>

            </div>

            {/* Address */}

            <div className="col-lg-4 col-md-6 mb-4">

              <div className="contact-box">

                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>

                <div className="contact-content">

                  <h4>Office Address</h4>

                  <p>
                    <strong>Sai Shirdi Cabs</strong>
                    <br />
Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                 Shirdi,Tel - Rahata,Dist Ahilyanagar,
                 Maharashtra, India - 423109                  </p>

                </div>

              </div>

            </div>

          </div>

          {/* Google Map */}

          <div className="row">

            <div className="col-lg-12">

              <div className="map-box">
<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2859.999117527117!2d74.4785!3d19.769361099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDQ2JzA5LjciTiA3NMKwMjgnNDIuNiJF!5e1!3m2!1sen!2sin!4v1788100150998!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>


              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default ContactInfo;